import { ReactNode } from 'react';

import { Cluster } from '@cast/types';

import { SidebarClusterSelect } from './SidebarClusterSelect';
import { SidebarSection } from './SidebarSection';
import { useSidebarCluster } from '../../SidebarClusterProvider';

type Props = {
  defaultPathTemplate: string;
  children: (cluster: Cluster) => ReactNode;
};

export function SidebarClusterSection(props: Props) {
  const cluster = useSidebarCluster();

  return (
    <SidebarSection title="Cluster" showTitleInDemo>
      <SidebarClusterSelect defaultPathTemplate={props.defaultPathTemplate} />
      {cluster ? props.children(cluster) : null}
    </SidebarSection>
  );
}
